import gql from 'graphql-tag';

const TRANSFER_STUDENT_MUTATION = gql`
  mutation transferStudent($where: TransferStudentWhereInput!, $data: TransferStudentInput!) {
    transferStudent(where: $where, data: $data) {
      id
    }
  }
`;

export default TRANSFER_STUDENT_MUTATION;
